/* eslint-disable no-unsafe-finally */
import { AxiosProgressEvent } from 'axios';
import { SPEED_TEST_FILE_SIZE, SPEED_TEST_TIMEOUT } from '../utils/constants.utils';
import { videoAxiosInstance } from './axiosInstances.service';
import { uploadToS3 } from './s3.service';

export const ONE_MB_IN_BYTES = 1048576;

const generateFakeBlob = (size: number) => new Blob([new ArrayBuffer(size * ONE_MB_IN_BYTES)], { type: 'video/webm' });

const getUploadTestUrl = () => videoAxiosInstance.get('/playground/url/presigned');

export const accSpeedTest = async () => {
  const uploadSpeeds:number[] = [];
  const signedUrlRes = await getUploadTestUrl();
  const data = generateFakeBlob(SPEED_TEST_FILE_SIZE);
  const file = new File([data], 'speed-test', { type: data.type });
  try {
    let lastTimeStamp = performance.now();
    let lastUploadedSize = 0;
    const onProgress = (e: AxiosProgressEvent) => {
      const chunkUploadSpeed = (e.loaded - lastUploadedSize) / (e.event.timeStamp - lastTimeStamp);
      uploadSpeeds.push(chunkUploadSpeed);
      lastTimeStamp = e.event.timeStamp;
      lastUploadedSize = e.loaded;
    };
    await uploadToS3(signedUrlRes.data?.data?.url, file, onProgress, SPEED_TEST_TIMEOUT);
  } catch (err: any) {
    console.log('Error / Request timeout:', err);
  } finally {
    const avgUploadSpeed = uploadSpeeds.length ? uploadSpeeds.reduce((acc, speed) => acc + speed, 0) / uploadSpeeds.length : 0;
    const uploadSpeedInMB = ((avgUploadSpeed / ONE_MB_IN_BYTES) * 1000) ?? 0; // MB/s
    return Number(uploadSpeedInMB.toFixed(2));
  }
};
